import Swal from "sweetalert2";

const SweetAlertMixin = {
    error(message = 'Something went wrong!') {
        return Swal.fire({
            icon: 'error',
            title: 'Fejl',
            text: message,
            confirmButtonText: 'Okay',
        });
    },

    htmlError(htmlMessage) {
        return Swal.fire({
            icon: 'error',
            title: 'Fejl',
            html: htmlMessage,
            confirmButtonText: 'Okay',
            customClass: {
                popup: 'text-center',
            },
        });
    },

    success(message = 'Success!') {
        return Swal.fire({
            icon: 'success',
            title: 'Success',
            text: message,
            confirmButtonText: 'Okay',
        });
    },

    confirm({title = 'Are you sure?', text = '', confirmText = 'Yes', cancelText = 'Cancel'} = {}) {
        return Swal.fire({
            icon: 'warning',
            title,
            text,
            showCancelButton: true,
            confirmButtonText: confirmText,
            cancelButtonText: cancelText,
        });
    },
};

export default SweetAlertMixin;
